import { createAction } from 'redux-actions';
import { SET_USERS, RESET, SET_LOADING } from './actionTypes';
import { getDeletedUsers } from './service';
import STATUS_CODE from '../../../../request/statusCode';

const setUsers = createAction(SET_USERS);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getUsers = () => {
  return dispatch => {
    dispatch(setLoading(true));
    return getDeletedUsers().then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        return dispatch(setUsers(res.data));
      }
      return dispatch(setUsers([]));
    });
  };
};

export { setUsers, reset, getUsers, setLoading };
